import FailureReasonsSummaryContainer from './failure-reasons-summary-container';

export default FailureReasonsSummaryContainer;
